module.exports = "<app-navbar></app-navbar>\r\n<app-home></app-home>\r\n<app-footer></app-footer>"